/* Sport Energy — Mobil-navigation (JS)
   FASE 1.5.0 (27. august 2026) — samme som header FASE 1.9.0: vaerktoejerne
   ud af overlayet, fire mekanisme-genveje ind, og Koeb igen foerst i raekken.
   FASE 1.4.0 (27. august 2026) — tom-tilstanden er skaaret ned. Den viste
   tre lister oven paa hinanden (seneste soegninger, populaere kategorier,
   Set for nylig), hvor den midterste var navigation menuen allerede har.
   Raekken laa 367 px nede, og med tastaturet oppe kunne man se overskriften
   og toppen af foerste kort. Nu: historik, vaerktoejer (de samme som paa
   desktop, fra motoren), og saa raekken.
   FASE 1.3.0 (27. august 2026) — overlayet bruger nu den delte soege-motor
   (sport-energy-search.js). Mobilen faar dermed for foerste gang de samme
   filter-genveje som desktop; CSS'en til dem har ligget ubrugt siden 1.0.0,
   fordi tabellen kun fandtes i header-filen. Med foelger seneste soegninger,
   Mente du ved nul traeffere, og produktraekken i bunden.
   Motoren loades af header-filen. Findes den ikke (fx hvis header-blokken
   fjernes), loader denne fil den selv ud fra sin egen script-adresse.
   FASE 1.2.0 (27. august 2026) — predictive search: samme tre rettelser som
   desktop-headeren (FASE 1.6.0). resources[limit_scope]=each, saa produkter
   ikke deler budget med kategorier og sider; loebenummer saa svar i forkert
   raekkefoelge ikke tegner gamle resultater; og en synlig fejl-tilstand i
   stedet for et lydloest catch. Kaldet SKAL holdes i takt med headerens.
   FASE 1.1.2 (2. juli 2026) — populære søgninger nu fra ægte GA4-data
   (top 6 over 90 dage). FASE 1.1.1 — fokus flyttes nu kun ved tastatur-brug, ikke
   ved tap (fjerner synlig fokus-ring om luk-knappen på iOS efter tap).
   FASE 1.1.0 — review-pas: fokus-fælde i dialoger, fokus
   følger drill-in/out, aria-expanded på menu-knap, delt cart-watcher-register
   (fetch wrappes kun én gang på tværs af header+mobil), drag-fysik efter
   fluid-principperne: 10px retnings-tærskel, rubber-band mod højre,
   velocity-dismiss ved flick, backdrop følger fingeren 1:1.
   FASE 1.0.0 — styrer mobil-menuens åbn/luk, drill-in/out, søge-overlay,
   scroll-kondensering og cart-badge. Routes/config via window.SEMobileNav
   (sat i Liquid-blokken, da asset-JS ikke kan rendere Liquid).
   Predictive search genbruger samme /search/suggest.json-mønster som
   desktop-headeren (kroner-ikke-øre, titel-før-pipe). */
// Faldback-loader: normalt henter header-filen motoren, men mobil-blokken
// skal kunne staa alene. Vagten sikrer at den kun hentes een gang.
(function motorFaldback(){
  if(window.SESearch || window.__seSearchIndlaeses) return;
  var SE_SEARCH_V = '2.1.0';
  var mig = document.currentScript ||
    document.querySelector('script[src*="sport-energy-mobile-nav.js"]');
  if(!mig || !mig.src) return;
  window.__seSearchIndlaeses = true;
  var el = document.createElement('script');
  el.src = mig.src.split('?')[0].replace('sport-energy-mobile-nav.js','sport-energy-search.js')
    + '?v=' + SE_SEARCH_V;
  document.head.appendChild(el);
})();

(function () {
  var root = document.querySelector('.se-mnav');
  if (!root) return;

  var cfg = (window.SEMobileNav || { search_url: '/search', predictive_search_url: '/search/suggest', cart_url: '/cart' });
  cfg = { searchUrl: cfg.search_url, predictiveUrl: cfg.predictive_search_url, cartUrl: cfg.cart_url };

  var head = root.querySelector('.se-mhead');
  var backdrop = root.querySelector('.se-mbackdrop');
  var panel = root.querySelector('.se-mpanel');
  var searchOverlay = root.querySelector('.se-msearch');
  var titleEl = root.querySelector('.se-mph-title');
  var backBtn = root.querySelector('.se-mph-back');
  var body = document.body;

  // ── Flyt fixed-elementer til <body> ──────────────────────────────────
  // Ella wrapper Custom Liquid i en shopify-section, der kan have en
  // transform. En transform-forælder gør position:fixed relativ til sig
  // selv (ikke viewporten), så panelet mister sin fulde højde. Vi flytter
  // header, backdrop, panel og søgning direkte under <body>, hvor ingen
  // transform-forælder findes. De beholder deres .se-mnav-scope ved at
  // ligge i en flyttet wrapper med samme klasse.
  var moved = document.createElement('div');
  moved.className = 'se-mnav se-mnav-portal';
  if (head) moved.appendChild(head);
  if (backdrop) moved.appendChild(backdrop);
  if (panel) moved.appendChild(panel);
  if (searchOverlay) moved.appendChild(searchOverlay);
  body.appendChild(moved);
  // Alle interaktive elementer (menu-knap, søge-knap, drill-rækker, panel)
  // bor nu i portalen. Peg root på portalen, så efterfølgende querySelector-
  // bindinger finder dem — ellers leder de i den nu-tomme originale .se-mnav.
  root = moved;

  var lastFocus = null; // for fokus-styring
  var menuBtn = root.querySelector('[data-se-menu-open]');

  // Spor om sidste interaktion var tastatur — så programmatisk fokus (og
  // dermed fokus-ringen) kun sættes ved tastatur-brug, ikke ved tap. På iOS
  // Safari viser et tap ellers en synlig ring, fordi den behandler
  // programmatisk .focus() som :focus-visible.
  var usingKeyboard = false;
  document.addEventListener('keydown', function (e) { if (e.key === 'Tab') usingKeyboard = true; }, true);
  document.addEventListener('pointerdown', function () { usingKeyboard = false; }, true);
  function focusIfKeyboard(el) { if (el && usingKeyboard) el.focus(); }

  // ── Body-padding under den fixed header ──
  body.classList.add('se-mnav-fixed');

  // ── Menu åbn/luk ──
  function openMenu() {
    lastFocus = document.activeElement;
    panel.classList.add('is-open');
    backdrop.classList.add('is-open');
    body.style.overflow = 'hidden';
    if (menuBtn) menuBtn.setAttribute('aria-expanded', 'true');
    focusIfKeyboard(panel.querySelector('.se-mph-close'));
  }
  function closeMenu() {
    panel.classList.remove('is-open');
    backdrop.classList.remove('is-open');
    body.style.overflow = '';
    drillOut(); // nulstil til rod
    if (menuBtn) menuBtn.setAttribute('aria-expanded', 'false');
    if (usingKeyboard && lastFocus && lastFocus.focus) lastFocus.focus();
  }

  // ── Drill-in / drill-out (spatial konsistens: sub glider ind fra højre) ──
  function drillIn(viewId, title) {
    var view = document.getElementById(viewId);
    if (!view) return;
    // deaktivér andre subs
    var subs = panel.querySelectorAll('.se-mview-sub');
    for (var i = 0; i < subs.length; i++) subs[i].classList.remove('is-active');
    view.classList.add('is-active');
    panel.classList.add('is-drilled');
    if (titleEl) titleEl.textContent = title || '';
    view.scrollTop = 0;
    focusIfKeyboard(backBtn); // fokus følger med ind i viewet (kun tastatur)
  }
  function drillOut() {
    var wasDrilled = panel.classList.contains('is-drilled');
    panel.classList.remove('is-drilled');
    var subs = panel.querySelectorAll('.se-mview-sub');
    for (var i = 0; i < subs.length; i++) subs[i].classList.remove('is-active');
    if (titleEl) titleEl.textContent = 'Menu';
    // Tilbage-knappen skjules nu — flyt fokus så det ikke falder til body.
    // (closeMenu kalder drillOut først og sætter derefter selv lastFocus.)
    if (wasDrilled && panel.classList.contains('is-open')) {
      focusIfKeyboard(panel.querySelector('.se-mph-close'));
    }
  }

  // ── Bind triggers ──
  if (menuBtn) menuBtn.addEventListener('click', openMenu);
  var closeBtn = root.querySelector('.se-mph-close');
  if (closeBtn) closeBtn.addEventListener('click', closeMenu);
  if (backdrop) backdrop.addEventListener('click', function () { closeMenu(); closeSearch(); });
  if (backBtn) backBtn.addEventListener('click', drillOut);

  // drill-triggers (rækker med data-se-drill)
  var drillRows = root.querySelectorAll('[data-se-drill]');
  for (var d = 0; d < drillRows.length; d++) {
    (function (rowEl) {
      rowEl.addEventListener('click', function () {
        drillIn(rowEl.getAttribute('data-se-drill'), rowEl.getAttribute('data-se-drill-title'));
      });
    })(drillRows[d]);
  }

  // Fokus-fælde: Tab bliver inden for den åbne dialog (menu eller søgning).
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var scope = null;
    if (searchOverlay && searchOverlay.classList.contains('is-open')) scope = searchOverlay;
    else if (panel.classList.contains('is-open')) scope = panel;
    if (!scope) return;
    var all = scope.querySelectorAll('a[href], button:not([disabled]), input');
    var vis = [];
    for (var i = 0; i < all.length; i++) { if (all[i].offsetParent !== null) vis.push(all[i]); }
    if (!vis.length) return;
    var first = vis[0], last = vis[vis.length - 1];
    if (e.shiftKey && document.activeElement === first) { last.focus(); e.preventDefault(); }
    else if (!e.shiftKey && document.activeElement === last) { first.focus(); e.preventDefault(); }
  });

  // Escape lukker (menu eller søgning)
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (searchOverlay && searchOverlay.classList.contains('is-open')) { closeSearch(); return; }
    if (panel.classList.contains('is-drilled')) { drillOut(); return; }
    if (panel.classList.contains('is-open')) closeMenu();
  });

  // ── Drag-to-dismiss på menu-panelet (swipe venstre lukker) ──
  // Fire fluid-principper indbygget: retning afgøres først efter ~10px (så
  // skrå scroll ikke fejlklassificeres), træk mod højre rubber-bander i stedet
  // for at stoppe hårdt, hurtige flicks lukker via velocity selv under
  // positions-tærsklen, og backdroppen følger panelet 1:1 (rumlig sammenhæng).
  (function armDrag() {
    var startX = 0, startY = 0, dx = 0, dragging = false, decided = false, horizontal = false;
    var lastX = 0, lastT = 0, vx = 0;
    var DECIDE_AT = 10;   // px før retning afgøres
    var DISMISS_AT = -80; // positions-tærskel
    var FLICK_V = -0.5;   // px/ms — hurtigt flick lukker uanset position
    panel.addEventListener('touchstart', function (e) {
      if (panel.classList.contains('is-drilled')) return; // kun i rod
      startX = e.touches[0].clientX; startY = e.touches[0].clientY;
      lastX = startX; lastT = e.timeStamp; vx = 0;
      dx = 0; dragging = true; decided = false; horizontal = false;
    }, { passive: true });
    panel.addEventListener('touchmove', function (e) {
      if (!dragging) return;
      var x = e.touches[0].clientX, y = e.touches[0].clientY;
      if (!decided) {
        var adx = Math.abs(x - startX), ady = Math.abs(y - startY);
        if (adx < DECIDE_AT && ady < DECIDE_AT) return; // for lidt bevægelse endnu
        decided = true;
        horizontal = adx > ady;
        if (horizontal) {
          panel.style.transition = 'none';
          if (backdrop) backdrop.style.transition = 'none'; // 1:1-tracking, ingen ease bag fingeren
        }
      }
      if (!horizontal) return;
      var raw = x - startX;
      // venstre følger 1:1; højre rubber-bander (blød grænse, ikke hård klods)
      dx = raw < 0 ? raw : raw / 4;
      panel.style.transform = 'translateX(' + dx + 'px)';
      // backdrop følger panelets position
      if (backdrop && dx < 0) backdrop.style.opacity = Math.max(0, 1 + dx / panel.offsetWidth);
      // glidende velocity (px/ms)
      var t = e.timeStamp, dt = t - lastT;
      // 40/60-udjævning: konvergerer på ~3 samples, så selv korte flicks
      // (få touch-events) måles korrekt — tungere udjævning når aldrig op.
      if (dt >= 3) { vx = 0.4 * vx + 0.6 * ((x - lastX) / dt); lastX = x; lastT = t; }
    }, { passive: true });
    panel.addEventListener('touchend', function () {
      if (!dragging) return;
      dragging = false;
      panel.style.transition = '';
      panel.style.transform = '';
      if (backdrop) { backdrop.style.transition = ''; backdrop.style.opacity = ''; }
      if (dx < DISMISS_AT || (dx < -30 && vx < FLICK_V)) closeMenu();
    });
  })();

  // ── Cart-badge (samme mønster som desktop) ──
  var badge = root.querySelector('.se-mbadge');
  function setCount(n) {
    if (!badge) return;
    badge.textContent = n;
    if (n > 0) badge.hidden = false; else badge.hidden = true;
  }
  function refreshCart() {
    fetch(cfg.cartUrl + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { setCount(c.item_count); })
      .catch(function () {});
  }
  function isCartWrite(u) {
    if (typeof u !== 'string') return false;
    return u.indexOf('/cart/add') >= 0 || u.indexOf('/cart/change') >= 0 || u.indexOf('/cart/update') >= 0 || u.indexOf('/cart/clear') >= 0;
  }
  // Delt watcher-register: fetch wrappes kun ÉN gang på tværs af header- og
  // mobil-JS (begge kører på alle skærmbredder). Ellers udløser hvert
  // læg-i-kurv to cart.js-kald.
  if (!window.__seCartWatchers) {
    window.__seCartWatchers = [];
    var _fetch = window.fetch;
    window.fetch = function () {
      var a = arguments, u = (a[0] && a[0].url) || a[0] || '';
      return _fetch.apply(this, a).then(function (res) {
        if (isCartWrite(u)) { for (var i = 0; i < window.__seCartWatchers.length; i++) window.__seCartWatchers[i](); }
        return res;
      });
    };
  }
  window.__seCartWatchers.push(refreshCart);
  ['cart:updated', 'cart:refresh', 'kaching:cart:updated'].forEach(function (ev) { document.addEventListener(ev, refreshCart); });

  // ── Scroll-kondensering ──
  var CONDENSE_AT = 60, EXPAND_AT = 15, condensed = false, ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    (window.requestAnimationFrame || function (cb) { setTimeout(cb, 16); })(function () {
      var y = window.pageYOffset || document.documentElement.scrollTop || 0;
      if (!condensed && y > CONDENSE_AT) { condensed = true; head.classList.add('is-condensed'); body.classList.add('se-mnav-condensed'); }
      else if (condensed && y < EXPAND_AT) { condensed = false; head.classList.remove('is-condensed'); body.classList.remove('se-mnav-condensed'); }
      ticking = false;
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  // ── USP-rotation ─────────────────────────────────────────────────────
  // Roterer roligt gennem budskaberne (~4,2 s hver) med blød fade.
  // Pauser når fanen er skjult (ingen grund til at animere off-screen) og
  // står stille hvis brugeren foretrækker mindre bevægelse.
  (function rotateUsp() {
    var items = Array.prototype.slice.call(root.querySelectorAll('.se-musp-item'));
    if (items.length < 2) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return; // ét budskab står stille — resten er i DOM men skjult

    // Bland rækkefølgen én gang per besøg (Fisher-Yates), så besøgende ser en
    // forskellig orden og et forskelligt første budskab hver gang — men stadig
    // hver besked præcis én gang per cyklus, ingen gengangere lige efter hinanden.
    for (var i = items.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = items[i]; items[i] = items[j]; items[j] = tmp;
    }
    // Vis det første i den blandede rækkefølge (nulstil HTML-standarden)
    var current = root.querySelector('.se-musp-item.is-active');
    if (current) current.classList.remove('is-active');
    var idx = 0;
    items[0].classList.add('is-active');

    var timer = null;
    function step() {
      items[idx].classList.remove('is-active');
      idx = (idx + 1) % items.length;
      items[idx].classList.add('is-active');
    }
    function start() { if (!timer) timer = setInterval(step, 4200); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop(); else start();
    });
    start();
  })();

  // ══════════════════════════════════════════════════════════════
  //  Søge-overlay + predictive search (genbruger desktop-mønster)
  // ══════════════════════════════════════════════════════════════
  var searchBtn = root.querySelector('[data-se-search-open]');
  var searchInput = root.querySelector('.se-msearch-field input');
  var searchBody = root.querySelector('.se-msearch-body');
  var searchCancel = root.querySelector('.se-msearch-cancel');

  function openSearch() {
    lastFocus = document.activeElement;
    searchOverlay.classList.add('is-open');
    // Tegn tom-tilstanden nu, saa Set for nylig og raekken er der fra start.
    // Ved foerste load kan motoren mangle; se:search-ready tegner om.
    visTom();
    body.style.overflow = 'hidden';
    setTimeout(function () { if (searchInput) searchInput.focus(); }, 120);
  }
  function closeSearch() {
    searchOverlay.classList.remove('is-open');
    body.style.overflow = '';
    if (searchInput) searchInput.value = '';
    visTom();
    if (usingKeyboard && lastFocus && lastFocus.focus) lastFocus.focus();
  }
  if (searchBtn) searchBtn.addEventListener('click', openSearch);
  if (searchCancel) searchCancel.addEventListener('click', closeSearch);

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function highlight(text, q) {
    var s = esc(text); if (!q) return s;
    var i = text.toLowerCase().indexOf(q.toLowerCase());
    if (i < 0) return s;
    return esc(text.slice(0, i)) + '<b class="hlq">' + esc(text.slice(i, i + q.length)) + '</b>' + esc(text.slice(i + q.length));
  }
  function money(kr) { return kr.toLocaleString('da-DK', { minimumFractionDigits: 0, maximumFractionDigits: 2 }) + ' kr.'; }
  function toKr(x) { if (x == null) return null; var n = parseFloat(String(x).replace(',', '.')); return isNaN(n) ? null : n; }
  function shortTitle(t) { return String(t || '').split('|')[0].trim(); }

  function motor() { return window.SESearch || null; }
  function chipHTML(sc) {
    return '<a class="se-msearch-chip" href="' + esc(sc.url) + '"><span class="ci"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">' + (sc.ikon || sc.icon || '') + '</svg></span>' + esc(sc.label) + '</a>';
  }

  // Raekken tegnes efter kroppen, fordi den kan kraeve et opslag.
  var sidsteSig = '';
  function tegnRaekke(q, antal, mit) {
    var m = motor(); if (!m || !searchBody) return;
    m.raekke(q, antal, function (titel, liste) {
      if (mit !== seq || !titel || !liste || !liste.length) return;
      // Samme signatur-vagt som desktop: uaendret raekke bliver staaende, saa
      // fjederen ikke spiller forfra ved hvert tastetryk.
      var sig = titel + '|' + liste.slice(0, 3).map(function (x) { return x.handle; }).join(',');
      var gammel = searchBody.querySelector('.se-msr-row');
      if (gammel && gammel.getAttribute('data-sig') === sig) return;
      if (gammel) gammel.parentNode.removeChild(gammel);
      var plads = searchBody.querySelector('.se-msr-slot');
      // Mobilen stabler kortene, saa der er ikke plads til flere end tre uden
      // at raekken skubber vaerktoejerne helt ned. Pilene er desktop-only.
      var tre = liste.slice(0, 3);
      if (plads) plads.innerHTML = m.raekkeHTML(titel, tre, 'se-msr');
      else searchBody.insertAdjacentHTML('beforeend', m.raekkeHTML(titel, tre, 'se-msr'));
      var ny = searchBody.querySelector('.se-msr-row');
      if (ny) {
        ny.setAttribute('data-sig', sig);
        if (sig === sidsteSig) ny.classList.add('is-rolig');
        sidsteSig = sig;
      }
      m.bind(searchBody);
    });
  }

  function defaultSearchBody() {
    // Tom tilstand: atletens egen historik foerst, saa de faste indgange.
    var m = motor();
    var sen = (m ? m.seneste() : []).slice(0, 4);
    var html = '';
    if (sen.length) {
      html += '<div class="se-msearch-sect">Seneste søgninger</div>';
      sen.forEach(function (x) {
        html += '<a class="se-msearch-sugg" href="' + esc(cfg.searchUrl) + '?q=' + encodeURIComponent(x) + '">' + esc(x) + '</a>';
      });
    }
    // Pladsholder til raekken. Den skal staa FOER vaerktoejerne: med
    // tastaturet oppe er der cirka 440 px at goere godt med, og raekken er
    // det eneste her der er produkter. Foerst laa den nederst og startede
    // 425 px nede, altsaa lige uden for skaermen.
    html += '<div class="se-msr-slot"></div>';
    var gen = m ? m.standardChips() : [];
    if (gen.length) {
      html += '<div class="se-msearch-sect">Genveje</div>';
      gen.forEach(function (v) { html += chipHTML(v); });
    }
    if (!html) {
      html += '<div class="se-msearch-empty">Søg efter et produkt, et mærke eller en situation.</div>';
    }
    return html;
  }
  // Tegner tom-tilstanden og haenger raekken paa.
  function visTom() {
    if (!searchBody) return;
    seq++;
    searchBody.innerHTML = defaultSearchBody();
    tegnRaekke('', 0, seq);
  }

  var t = null, seq = 0;
  function runSearch(q) {
    // limit_scope=each: se headerens FASE 1.6.0. Uden den deles loftet paa 6
    // mellem alle fem typer, og produktlisten bliver to lange.
    var url = cfg.predictiveUrl + '?q=' + encodeURIComponent(q) +
      '&resources[type]=product,collection,page,article,query' +
      '&resources[limit]=6&resources[limit_scope]=each' +
      '&resources[options][unavailable_products]=last';
    var mit = ++seq;
    fetch(url, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (mit !== seq) return;
        var r = (data.resources && data.resources.results) || {};
        renderSearch(q, {
          products: (r.products || []).map(function (p) {
            var parts = String(p.title || '').split('|');
            var name = parts[0].trim();
            var flavour = parts.length > 1 ? parts.slice(1).join('|').trim() : '';
            var v = (p.variants && p.variants[0]) || null;
            return { title: name, meta: flavour || p.vendor || '', url: p.url,
              image: (p.featured_image && p.featured_image.url) || p.image || null,
              price: (p.price != null) ? toKr(p.price) : (v && v.price != null ? toKr(v.price) : null) };
          }),
          collections: (r.collections || []).map(function (c) { return { title: shortTitle(c.title), url: c.url }; }),
          pages: (r.pages || []).map(function (p) { return { title: shortTitle(p.title), url: p.url }; }),
          articles: (r.articles || []).map(function (a) { return { title: shortTitle(a.title), url: a.url }; })
        });
      })
      .catch(function () {
        if (mit !== seq) return;
        if (searchBody) {
          searchBody.innerHTML = '<div class="se-msearch-empty">Kunne ikke hente forslag lige nu. Tryk søg for at se hele butikken.</div>';
        }
      });
  }

  function renderSearch(q, res) {
    var html = '';
    var m = motor();
    var it = m ? m.intent(q) : null;
    var tomt = !res.products.length && !res.collections.length && !res.pages.length && !res.articles.length;
    // Nul traeffere, men vi kan gaette hvad der menes.
    if (tomt && it && it.mente) {
      html += '<div class="se-msearch-empty"><b>Ingen produkter hedder ' + esc(q) + '</b>Vi tror du mener ' + esc(it.mente) + '.</div>';
      html += '<div class="se-msearch-sect">Mente du</div>';
      html += '<a class="se-msearch-sugg" href="' + esc(cfg.searchUrl) + '?q=' + encodeURIComponent(it.soeg || it.mente) + '">' + esc(it.mente) + '</a>';
    }
    // Filter-genveje: mekanisme foer produkt. Findes nu ogsaa paa mobil.
    var gen = m ? m.chips(q) : [];
    if (gen.length) {
      html += '<div class="se-msearch-sect">Filtrér direkte</div>';
      gen.forEach(function (sc) { html += chipHTML(sc); });
    }
    // Produkter
    if (res.products.length) {
      html += '<div class="se-msearch-sect">Produkter</div>';
      res.products.forEach(function (p) {
        var img = p.image ? '<img class="se-msearch-thumb" src="' + esc(p.image) + '" alt="" loading="lazy">' : '<span class="se-msearch-thumb"></span>';
        var meta = p.meta ? '<span class="se-msearch-mt">' + esc(p.meta) + '</span>' : '';
        var price = (p.price != null) ? '<span class="se-msearch-pr">' + money(p.price) + '</span>' : '';
        html += '<a class="se-msearch-item" href="' + esc(p.url) + '">' + img +
          '<span class="se-msearch-body-txt"><span class="se-msearch-nm">' + highlight(p.title, q) + '</span>' + meta + '</span>' + price + '</a>';
      });
    }
    // Kategorier
    if (res.collections.length) {
      html += '<div class="se-msearch-sect">Kategorier</div>';
      res.collections.slice(0, 4).forEach(function (c) {
        html += '<a class="se-msearch-sugg" href="' + esc(c.url) + '">' + highlight(c.title, q) + '</a>';
      });
    }
    // Sider + guides
    var pages = res.pages.concat(res.articles);
    if (pages.length) {
      html += '<div class="se-msearch-sect">Sider og guides</div>';
      pages.slice(0, 4).forEach(function (p) {
        html += '<a class="se-msearch-sugg" href="' + esc(p.url) + '">' + highlight(p.title, q) + '</a>';
      });
    }
    if (tomt && !(it && it.mente)) {
      html += '<div class="se-msearch-empty"><b>Ingen produkter matcher ' + esc(q) + '</b>Prøv et andet ord, eller se hvad du sidst kiggede på.</div>';
    }
    // Se alle: kun naar der ER noget at se. Ved nul traeffere foerer den kun
    // til en tom side.
    if (res.products.length) {
      html += '<a class="se-msearch-foot" href="' + esc(cfg.searchUrl) + '?q=' + encodeURIComponent(q) + '">Se alle resultater for ' + esc(q) + '<svg viewBox="0 0 24 24"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg></a>';
    }
    if (searchBody) searchBody.innerHTML = html;
    tegnRaekke(q, res.products.length, seq);
  }

  if (searchInput) {
    searchInput.addEventListener('input', function () {
      var q = searchInput.value.trim();
      clearTimeout(t);
      if (q.length < 2) { visTom(); return; }
      t = setTimeout(function () { runSearch(q); }, 160);
    });
    searchInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault(); // formen ville også submitte — undgå dobbelt navigation
        var q = searchInput.value.trim();
        if (!q) return;
        if (window.SESearch) window.SESearch.husk(q);
        window.location.href = cfg.searchUrl + '?q=' + encodeURIComponent(q);
      }
    });
  }
  // sæt tom-tilstand ved load, og tegn om naar motoren melder sig
  if (searchBody) searchBody.innerHTML = defaultSearchBody();
  document.addEventListener('se:search-ready', function () {
    if (searchOverlay && searchOverlay.classList.contains('is-open') &&
        searchInput && searchInput.value.trim().length < 2) visTom();
  });
})();